import React from 'react';
import { X } from 'lucide-react';

interface BillingFiltersProps {
  status: string;
  startDate: string;
  endDate: string;
  onStatusChange: (status: string) => void;
  onDateChange: (startDate: string, endDate: string) => void;
}

const BillingFilters: React.FC<BillingFiltersProps> = ({
  status,
  startDate,
  endDate,
  onStatusChange,
  onDateChange,
}) => {
  const handleClearFilters = () => {
    onStatusChange('');
    onDateChange('', '');
  };

  const hasActiveFilters = status || startDate || endDate;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Status Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Status</label>
          <select
            value={status}
            onChange={e => onStatusChange(e.target.value)}
            className="w-full bg-gray-800 border border-gray-700 text-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:border-[#23F47C] transition-colors"
          >
            <option value="">All Statuses</option>
            <option value="succeeded">Paid</option>
            <option value="pending">Pending</option>
            <option value="failed">Failed</option>
          </select>
        </div>

        {/* Start Date Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">Start Date</label>
          <input
            type="date"
            value={startDate}
            onChange={e => onDateChange(e.target.value, endDate)}
            className="w-full bg-gray-800 border border-gray-700 text-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:border-[#23F47C] transition-colors"
          />
        </div>

        {/* End Date Filter */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">End Date</label>
          <input
            type="date"
            value={endDate}
            onChange={e => onDateChange(startDate, e.target.value)}
            className="w-full bg-gray-800 border border-gray-700 text-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:border-[#23F47C] transition-colors"
          />
        </div>
      </div>

      {/* Clear Filters Button */}
      {hasActiveFilters && (
        <button
          onClick={handleClearFilters}
          className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-gray-300 transition-colors"
        >
          <X size={16} />
          Clear Filters
        </button>
      )}
    </div>
  );
};

export default BillingFilters;
